import { useLayoutEffect, useState } from "react";

const THEME_KEY = "dexter-borrower-theme";

function readThemePreference() {
  try {
    const stored = window.localStorage.getItem(THEME_KEY);
    return stored === "light" || stored === "dark" ? stored : null;
  } catch {
    return null;
  }
}

export function useBorrowerTheme() {
  const [preference, setPreference] = useState(readThemePreference);
  const [systemDark, setSystemDark] = useState(() =>
    window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false
  );
  const theme = preference ?? (systemDark ? "dark" : "light");

  useLayoutEffect(() => {
    const media = window.matchMedia?.("(prefers-color-scheme: dark)");
    if (!media) return;
    const update = (event) => setSystemDark(event.matches);
    setSystemDark(media.matches);
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);

  useLayoutEffect(() => {
    document.body.dataset.borrowerTheme = theme;
    return () => { delete document.body.dataset.borrowerTheme; };
  }, [theme]);

  const toggleTheme = () => {
    const next = theme === "dark" ? "light" : "dark";
    setPreference(next);
    try { window.localStorage.setItem(THEME_KEY, next); } catch { /* Keep the choice for this session. */ }
  };
  return { theme, toggleTheme };
}
